const triggerInsuranceWebhook = async (bookingId, engineNumber, exShowroomPrice) => {
    const myHeaders = new Headers();
    // myHeaders.append("Authorization", ""); // No auth token provided in instructions

    const formdata = new FormData();
    formdata.append("Booking_id", bookingId);
    if (engineNumber) formdata.append("EngineNumber", engineNumber);
    if (exShowroomPrice) formdata.append("ExShowroomPrice", exShowroomPrice);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    try {
        const response = await fetch(
            `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/InsuranceCasesTriggerV1`,
            requestOptions
        );
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.text();
        console.log("Insurance Webhook Result:", result);
        return { success: true, data: result };
    } catch (error) {
        console.error("Insurance Webhook Error:", error);
        throw error;
    }
};

export default triggerInsuranceWebhook;

